/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend Developer
 * @Email: sgarcia@ibl.mx
 */

import AddVehiclesModalApp from '../Functionality/AddVehiclesModalApp';
import { TABLES } from '../../../../Apis/Tables';
import { vehicleListToLabel } from '../../../../Apis/functions';
import CustomModal from '../../../../components/Modal/CustomModal';
import NotInformation from '../../../../components/NotInformation';
import CustomCard from '../../../../components/CustomCard';
import CustomChip from '../../../../components/CustomChip';
import { colors } from '../../../../enums/colors';
import CustomMediumChip from '../../../../components/CustomMediumChip';
import { Box } from '@mui/material';
import { POSITION_MODEL } from '../../../../Helpers/PositionModel';
import { IconColorPalette, ModelIcon, VehicleChip } from '../../../../components/buttons/IconButtons';
import CustomAutocompleteSearch from '../../../../components/CustomAutocompleteSearch';
import { SEARCH_USERS_MODEL } from '../../../../components/table/Model/TableModel';

const AddVehiclesModal = ({ show, onHide, selectedId, setModified, modified }) => {
    const { handleAdd, selectedVehicle, setSelectedVehicle, t, id } = AddVehiclesModalApp({
        onHide,
        selectedId,
        setModified,
        modified,
        show,
    });
    return (
        <CustomModal
            show={show}
            title={t('add_vehicle')}
            size='md'
            onHide={() => {
                onHide();
            }}
            onConfirm={() => handleAdd(selectedVehicle)}
        >
            <CustomAutocompleteSearch
                id='slt_avm_add_vehicle'
                label='vehicle'
                itemSelected={selectedVehicle}
                setItemSelected={(vehicle) => {
                    if (!vehicle) return;
                    setSelectedVehicle((prev) => (prev.some((v) => v.id === vehicle.id) ? prev : [...prev, vehicle]));
                }}
                userTypeIdsSearch={[]}
                required
                keyId='id'
                bodyApi={{...SEARCH_USERS_MODEL, model:TABLES.VEHICLE_NOT_ASSIGNED_TO_CONTRACT, modelId: id }}
                model={TABLES.VEHICLE_NOT_ASSIGNED_TO_CONTRACT}
                listTransform={vehicleListToLabel}
                placeholder={t('search_vehicle_by_brand_subbrand_or_license_plate')}
                reset
                Icon={VehicleChip}
            />

            <CustomCard classes='mt-3' classCard={'card-border-8px'} classContent={'p-0'}>
                <div className='mt-3 mx-3 mb-2'>
                    <div className='d-flex align-items-center gap-2 ml-2 mr-2 mb-2'>
                        <p className={'font-color-general-950 fs-14px ml-2 ibl-font-w-600'}>{t('selected_vehicles')}</p>
                        <CustomChip
                            background={colors.shades200}
                            legend={`${selectedVehicle?.length || 0}`}
                            border={colors.shades300}
                            fontColor={colors.shades500}
                        />
                    </div>
                    <div className={'border-bottom-shades-300'} />{' '}
                </div>

                {selectedVehicle?.length > 0 ? (
                    <div className='d-flex flex-column gap-4 p-2 m-2'>
                        {selectedVehicle.map((vehicle) => (
                            <CustomMediumChip
                                key={vehicle.id}
                                title={vehicle.label}
                                completeWidth
                                showAvatar
                                disabled={false}
                                Icon={VehicleChip}
                                iconPosition={POSITION_MODEL.LEFT}
                                onClickClose={() =>
                                    setSelectedVehicle((prev) => prev.filter((item) => item.id !== vehicle.id))
                                }
                            >
                                <Box className='d-flex justify-content-between align-items-center pt-3 w-100'>
                                    <Box className='d-flex w-100'>
                                        {vehicle.model && (
                                            <Box className='d-flex align-items-center gap-1 w-50'>
                                                <ModelIcon />
                                                <span className='text-shades-600 text-truncate'>{vehicle.model}</span>
                                            </Box>
                                        )}

                                        {vehicle.color && (
                                            <Box className='d-flex align-items-center gap-1 w-50 justify-content-start'>
                                                <IconColorPalette />
                                                <span className='text-shades-600'>{vehicle.color}</span>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            </CustomMediumChip>
                        ))}
                    </div>
                ) : (
                    <div className='m-3'>
                        <NotInformation text={t('no_vehicles_added')} card />
                    </div>
                )}
            </CustomCard>
        </CustomModal>
    );
};

export default AddVehiclesModal;
